<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.jcj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Extrusion Machine</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;">Scope of application</span>
        </b>
        <span style="font-size:12.0pt;font-family:宋体;">：</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">Soft and rigid</span>
        <span style="font-size:12.0pt;font-family:Arial;">PVC</span>
        <span style="font-size:12.0pt;font-family:宋体;">、High and low pressure</span>
        <span style="font-size:12.0pt;font-family:Arial;">PE</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">ABS</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">AS</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">EVA</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">PA</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">PC</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">PEI</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">POM</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">PP</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">PMMA</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">TPU</span>
        <span style="font-size:12.0pt;font-family:宋体;">、</span>
        <span style="font-size:12.0pt;font-family:Arial;">PS</span>
        <span style="font-size:12.0pt;font-family:宋体;">etc..</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;">Product Type</span>
        </b>
        <span style="font-size:12.0pt;font-family:宋体;">：</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">Single and multi-lumen tubes, multi-color co-extruded tubes, special-shaped tubes, single and multi-layer sheets, recycled materials, mixed color granulation.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;">Device Parameters</span>
        </b>
        <span style="font-size:12.0pt;font-family:宋体;">：</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;color:black;">Special model machines can be made according to requirements of customers.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:black;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <table
        style="width:100.0%;"
        class="ke-zeroborder"
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="100%"
      >
        <tbody>
          <tr>
            <td>
              <table
                style="width:393.75pt;background:black;"
                class="ke-zeroborder"
                border="0"
                cellpadding="0"
                cellspacing="1"
                width="525"
              >
                <tbody>
                  <tr>
                    <td style="background:#B693C1;" valign="top" width="65">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:#B693C1;" valign="top" width="70">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">Screw Diameter</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">
                          <br>MM
                        </span>
                      </p>
                    </td>
                    <td style="background:#B693C1;" valign="top" width="85">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">Length-Diameter Ratio</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">
                          <br>L/D
                        </span>
                      </p>
                    </td>
                    <td style="background:#B693C1;" valign="top" width="70">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">Screw Speed</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">
                          <br>RPM
                        </span>
                      </p>
                    </td>
                    <td style="background:#B693C1;" valign="top" width="63">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">Production</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">
                          <br>Kg/h
                        </span>
                      </p>
                    </td>
                    <td style="background:#B693C1;" valign="top" width="129">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">Main Engine Power</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">
                          <br>KW
                        </span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ15</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">12--80</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">1--2</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">0.55--1.1</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:#E8C2C2;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:#E8C2C2;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ20</span>
                      </p>
                    </td>
                    <td style="background:#E8C2C2;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                      </p>
                    </td>
                    <td style="background:#E8C2C2;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">16--90</span>
                      </p>
                    </td>
                    <td style="background:#E8C2C2;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">2--4</span>
                      </p>
                    </td>
                    <td style="background:#E8C2C2;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">0.75--1.5</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ25</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">18--110</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">3--6</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">1.5--2.2</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:#FAF0DA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:#FAF0DA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ30</span>
                      </p>
                    </td>
                    <td style="background:#FAF0DA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">28</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">30</span>
                      </p>
                    </td>
                    <td style="background:#FAF0DA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">17--120</span>
                      </p>
                    </td>
                    <td style="background:#FAF0DA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">4--10</span>
                      </p>
                    </td>
                    <td style="background:#FAF0DA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">2.2--3</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ35</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">28</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">15--120</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">5--15</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">3--5.5</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:#DAF4FA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:#DAF4FA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ40</span>
                      </p>
                    </td>
                    <td style="background:#DAF4FA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">28</span>
                      </p>
                    </td>
                    <td style="background:#DAF4FA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">15--110</span>
                      </p>
                    </td>
                    <td style="background:#DAF4FA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">7--25</span>
                      </p>
                    </td>
                    <td style="background:#DAF4FA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">5.5--7.5</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ45</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">28</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">15--110</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">12--35</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">7.5--11</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:#E7FADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:#E7FADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ50</span>
                      </p>
                    </td>
                    <td style="background:#E7FADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">28</span>
                      </p>
                    </td>
                    <td style="background:#E7FADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">12--100</span>
                      </p>
                    </td>
                    <td style="background:#E7FADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">20--50</span>
                      </p>
                    </td>
                    <td style="background:#E7FADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">15--22</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ65</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">28</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">36</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">8--90</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">40--130</span>
                      </p>
                    </td>
                    <td style="background:white;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">22--45</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="background:#FAFADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
                      </p>
                    </td>
                    <td style="background:#FAFADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">Φ90</span>
                      </p>
                    </td>
                    <td style="background:#FAFADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">25</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">28</span>
                        <span style="font-size:9.0pt;font-family:宋体;color:black;">、</span>
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">38</span>
                      </p>
                    </td>
                    <td style="background:#FAFADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">8--80</span>
                      </p>
                    </td>
                    <td style="background:#FAFADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">50--250</span>
                      </p>
                    </td>
                    <td style="background:#FAFADA;">
                      <p style="text-align:center;" align="center">
                        <span style="font-size:9.0pt;font-family:Arial;color:black;">45--110</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p style="text-align:left;" align="left">
                <span style="font-size:9.0pt;font-family:Arial;color:black;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Arial;color:black;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p style="text-align:left;" align="left">
                <span style="font-size:9.0pt;font-family:宋体;color:black;"></span>
                <span style="font-size:9.0pt;font-family:Arial;color:black;"></span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jcj: require("../../../assets/img/common/jcj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/jcj.vue